export interface ISignInFormFields {
  email: string;
  password: string;
}

export const signInFormFields = {
  email: 'email',
  password: 'password',
};
